import React, { Component } from "react";
import Modal from "antd/lib/modal";

const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION;
const POLL_INTERVAL = 60 * 1000;

class VersionChecker extends Component {
    state = {
        updateAvailable: false
    };

    componentDidMount() {
        this.pollTimer = setInterval(this.checkForUpdate, POLL_INTERVAL);
    }

    componentWillUnmount() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
        }
    }

    checkForUpdate = () => {
        fetch("/version.json?t=" + Date.now())
            .then(res => {
                if (!res.ok) return null;
                return res.json();
            })
            .then(data => {
                if (data && data.version && data.version !== CURRENT_VERSION) {
                    clearInterval(this.pollTimer);
                    this.setState({ updateAvailable: true });
                }
            })
            .catch(() => {});
    };

    handleRefresh = () => {
        window.location.reload(true);
    };

    // Dismiss without refreshing so the user can finish what they're doing.
    // Restart polling so the reminder pops again on the next check (the
    // deployed version is still newer), rather than never returning.
    handleDismiss = () => {
        this.setState({ updateAvailable: false });
        if (!this.pollTimer) {
            this.pollTimer = setInterval(this.checkForUpdate, POLL_INTERVAL);
        }
    };

    render() {
        return (
            <Modal
                title="Update Available"
                visible={this.state.updateAvailable}
                onOk={this.handleRefresh}
                okText="Refresh Now"
                onCancel={this.handleDismiss}
                cancelText="Later"
                closable={true}
                maskClosable={true}
                keyboard={true}
            >
                <p>
                     A new version of the application is available. Please click <strong>Refresh Now</strong> to load the latest updates.
                </p>
            </Modal>
        );
    }
}

export default VersionChecker;
